// File generated from our OpenAPI spec
import { StripeResource } from '../../StripeResource.js';
const stripeMethod = StripeResource.method;
export const Settings = StripeResource.extend({
    retrieve: stripeMethod({ method: 'GET', fullPath: '/v1/tax/settings' }),
    update: stripeMethod({ method: 'POST', fullPath: '/v1/tax/settings' }),
});
